import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'calsoft-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {

  today: Date = new Date();

  @Input() data: any;

  @Output() pickUp: EventEmitter<any> = new EventEmitter<any>();

  @Output() additionalMessgae: EventEmitter<any> = new EventEmitter<any>();


  constructor(private _formBuilder: FormBuilder,) { }


  ngOnInit(): void {

    
  }



  firstFormGroup = this._formBuilder.group({
    pickUp: [''],
    additionalMessgae: [''],
  });

}
